import { Events } from '|>/shared/events'
import { addClass, img, removeAttribute, removeClass } from '|>/shared/h'
import { on, register } from '|>/shared/vjs'
import { BaseComponent } from '../base'

import './poster.css'

@register
export class Poster extends BaseComponent {
  declare fallback: string | undefined
  declare imgEl?: HTMLImageElement

  /*
   * Image load delayed in time, so while image loading,
   * another call to disable it may happen.
   * This is a state of should poster be shown or not.
   */
  private isOn: boolean = false

  setPoster(url: string): void {
    if (!this.isOn) return

    removeClass(this.el_, 'vjs-x-poster-hidden')

    if (!this.imgEl) {
      this.imgEl = img('.vjs-x-poster-img')
      this.el_.appendChild(this.imgEl)
    }

    if (this.imgEl) this.imgEl.src = url
  }

  loadImage(poster: string) {
    const img = new Image()
    img.src = poster

    img.onload = () => this.setPoster(img.src)
    img.onerror = () => {
      if (this.fallback) this.setPoster(this.fallback)
    }
  }

  @on(Events.Controls.SetPoster)
  onNewPoster(newPoster: Events.Controls.SetPoster) {
    let poster: string | undefined

    if (typeof newPoster !== 'string') {
      poster = newPoster?.poster
      this.fallback = newPoster?.fallback
    } else poster = newPoster

    poster = poster || this.fallback

    if (poster) {
      // show
      this.isOn = true
      this.loadImage(poster)
    } else {
      // hide
      this.isOn = false
      addClass(this.el_, 'vjs-x-poster-hidden')
      if (this.imgEl) this.imgEl.src = ''
      removeAttribute(this.el_, 'style')
    }
  }
}

Poster.options = {
  className: 'vjs-x-poster',
}
